import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, TemplateRef } from '@angular/core';
import { DataTableColumn } from '../../../shared/ui/data-table/data-table.component';
import { ManagerService, SellerService, FileService } from '../../../core';
import { PopupMessageService } from '../../../shared/message/services/message.service';
import { managerApi } from '../../../config';

@Component({
  selector: 'app-finalize-challenge-modal',
  templateUrl: './finalize-challenge-modal.component.html',
  styleUrls: ['./finalize-challenge-modal.component.scss']
})
export class FinalizeChallengeModalComponent implements OnChanges {
  @Input() triggerChallenge: any = null;
  @Output() closed = new EventEmitter<void>();

  @ViewChild('finalizeRegionTpl') finalizeRegionTpl!: TemplateRef<any>;
  @ViewChild('finalizeGenerateTpl') finalizeGenerateTpl!: TemplateRef<any>;
  @ViewChild('finalizeUploadTpl') finalizeUploadTpl!: TemplateRef<any>;

  isModalOpen = false;
  finalizeChallengeData: any = null;
  finalizeSelectedCategory: string = '';
  finalizeCategoryItem: any = null;
  finalizeColumns: DataTableColumn[] = [];
  finalizeRegionList: any[] = [];
  finalizeUploadSubmitBtn: boolean = true;
  finalizeLoading: string | null = null;
  categoryList: any[] = [];

  get finalizeFilteredRows(): any[] {
    return this.finalizeRegionList.filter((item: any) => item.category === this.finalizeSelectedCategory);
  }

  constructor(
    private managerService: ManagerService,
    private sellerService: SellerService,
    private fileService: FileService,
    private popupMessageService: PopupMessageService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['triggerChallenge'] && changes['triggerChallenge'].currentValue) {
      this.loadAndOpen(changes['triggerChallenge'].currentValue);
    }
  }

  private loadAndOpen(val: any) {
    const data = val.challengeData;
    const categories = val.categories;
    const countryGroupList = val.countryGroupList;
    this.finalizeChallengeData = data;
    this.categoryList = categories.uploadFileCategoryList;
    this.finalizeCategoryItem = this.categoryList[0];
    this.finalizeSelectedCategory = this.finalizeCategoryItem.value;
    this.finalizeRegionList = this.buildFinalizeRegionList(
      this.categoryList,
      data.regions,
      countryGroupList,
      data
    );
    this.isModalOpen = true;
    setTimeout(() => { this.buildFinalizeColumns(); });
  }

  closeModal() {
    this.isModalOpen = false;
    this.finalizeChallengeData = null;
    this.finalizeCategoryItem = null;
    this.finalizeColumns = [];
    this.finalizeRegionList = [];
    this.finalizeUploadSubmitBtn = true;
    this.finalizeLoading = null;
    this.closed.emit();
  }

  onFinalizeCategoryChange(item: any) {
    this.finalizeCategoryItem = item;
    this.finalizeSelectedCategory = item.value;
    this.buildFinalizeColumns();
    if (this.finalizeSelectedCategory === 'TERMS_AND_CONDITIONS') {
      const termsCategory = this.finalizeRegionList.filter((x: any) => x.category === 'TERMS_AND_CONDITIONS');
      if (termsCategory.find((x: any) => x.flag === false)) {
        this.finalizeUploadSubmitBtn = true;
      }
    }
  }

  finalizeGetFile(eve: any, item: any) {
    item.data = eve.target.files[0];
    item.showUploadBtn = true;
    item.uploadSuccess = false;
    item.flag = false;
  }

  finalizeRemoveFile(item: any) {
    item.data = '';
    item.showUploadBtn = false;
    item.flag = true;
    item.uploadSuccess = false;
    item.uploadFailure = false;
  }

  finalizeUploadFile(item: any) {
    item.isUploading = true;
    const uploadData = new FormData();
    uploadData.append('file-to-be-uploaded', item.data);
    const challengeId = item.id;
    let param = '?CustomChallengeId=' + challengeId + '&region=' + item.region + '&category=' + this.finalizeSelectedCategory;
    if (item.countryGroupId) {
      param = param + '&countryGroupId=' + item.countryGroupId;
    }
    this.sellerService.uploadAttachedDocument(uploadData, param).subscribe(
      (data: any) => {
        if (data.message) {
          item.flag = true;
          item.showUploadBtn = false;
          item.uploadSuccess = true;
          item.uploadFailure = false;
          item.name = item.data.name;
          item.data = '';
          item.isUploading = false;
          if (this.finalizeSelectedCategory === 'TERMS_AND_CONDITIONS') {
            const uploadedTerms = this.finalizeRegionList.filter((x: any) => x.category === 'TERMS_AND_CONDITIONS');
            if (uploadedTerms.find((x: any) => x.flag === false)) {
              this.finalizeUploadSubmitBtn = true;
            } else {
              this.finalizeUploadSubmitBtn = false;
            }
          }
        }
      },
      () => {
        this.finalizeUploadSubmitBtn = true;
        item.flag = false;
        item.showUploadBtn = true;
        item.uploadSuccess = false;
        item.uploadFailure = true;
        item.isUploading = false;
      }
    );
  }

  finalizeSubmitUploadTerms() {
    this.finalizeUploadSubmitBtn = true;
    const params = 'id=' + this.finalizeChallengeData.id + '&status=PENDING_FINAL_APPROVAL';
    this.managerService.submitForApproval(params).subscribe(
      (data: any) => {
        if (data !== '') {
          this.finalizeUploadSubmitBtn = false;
          this.popupMessageService.showSuccess(
            'Uploaded Terms and condition successfully',
            'success',
            'salesChallengeToggleForm'
          );
          this.closeModal();
        }
      },
      () => {}
    );
  }

  finalizeGenerateFile(list: any) {
    this.finalizeLoading = list.key;
    const id = list.id;
    let req = 'customChallengeId=' + id + '&region=' + list.region;
    if (list.countryGroupId) {
      req = req + '&countryGroupId=' + list.countryGroupId;
    }
    let url = '';
    if (list.category === 'TERMS_AND_CONDITIONS') {
      url = managerApi.generateTandConditionsFile + req;
    } else if (list.category === 'ELIGIBLE_PRODUCT_LIST') {
      url = managerApi.generateEligProductsDocumentationAsDownloadable + req;
    }
    this.fileService.downloadFile(url).subscribe({
      next: () => { this.finalizeLoading = null; },
      error: () => { this.finalizeLoading = null; },
    });
  }

  private buildFinalizeColumns() {
    const cols: DataTableColumn[] = [
      { field: 'region', header: 'Region / Country Group', cellTemplate: this.finalizeRegionTpl }
    ];
    if (this.finalizeSelectedCategory !== 'OTHERS') {
      cols.push({ field: 'generate', header: 'Generate File', cellTemplate: this.finalizeGenerateTpl });
    }
    cols.push({ field: 'upload', header: 'Upload File', cellTemplate: this.finalizeUploadTpl });
    this.finalizeColumns = cols;
  }

  private buildFinalizeRegionList(categories: any[], regions: any[], countryGroupList: any, data: any): any[] {
    const regionList: any[] = [];
    const targetDate = new Date('2025-10-25');
    categories.forEach((category: any) => {
      regions.forEach((region: any) => {
        const normalizedDateStr = data.startDate.replace(/\+0000$/, 'Z');
        const startDate = new Date(normalizedDateStr);
        const hasCountryGroups =
          startDate > targetDate &&
          Array.isArray(countryGroupList[region]) &&
          countryGroupList[region].length > 0;
        if (hasCountryGroups) {
          countryGroupList[region].forEach((countryGroup: any) => {
            regionList.push({
              key: region + countryGroup.id,
              id: data.id,
              region: region,
              countryGroupId: countryGroup.id,
              countryGroupName: countryGroup.name,
              category: category.value,
              data: '',
              flag: false,
              showUploadBtn: false,
            });
          });
        } else {
          regionList.push({
            key: region,
            id: data.id,
            region: region,
            category: category.value,
            data: '',
            flag: false,
            showUploadBtn: false,
            name: '',
          });
        }
      });
    });
    return regionList;
  }
}
